module.exports = __webpack_public_path__ + "static/img/case_detail_09_1.d511c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_09_1.png
// module id = ASRB
// module chunks = 34